unit uHelper;

interface

uses
  System.SysUtils;

type
  THelper = class
    public
      class function FormatDateTimeString(const InputStr: string): string;
  end;

implementation

{ THelper }

class function THelper.FormatDateTimeString(const InputStr: string): string;
var
  DateTimeValue: TDateTime;
  FormatSettings: TFormatSettings;
begin
  Result := 'Ungültiges Datum'; // Standardwert, falls Umwandlung fehlschlägt

  // FormatSettings anpassen, um das Datum korrekt zu interpretieren
  FormatSettings := TFormatSettings.Create;
  FormatSettings.ShortDateFormat := 'yyyy-mm-dd';
  FormatSettings.DateSeparator := '-';
  FormatSettings.LongTimeFormat := 'hh:nn:ss';
  FormatSettings.TimeSeparator := ':';

  try
    // Umwandlung von String nach TDateTime
    DateTimeValue := StrToDateTime(InputStr, FormatSettings);

    // Formatierte Ausgabe
    Result := 'am ' + FormatDateTime('dd.mm.yyyy', DateTimeValue) +
              ' um ' + FormatDateTime('hh:nn', DateTimeValue) + ' Uhr';
  except
    on E: Exception do
      Result := 'Fehler: ' + E.Message;
  end;
end;

end.
